export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/image_placeholder-ebe9884b2152a08a525fcd5054019532.jpg";